<template>
  <div
    v-if="
      insurance &&
      String(insurance).length > 0 &&
      reconciliationData &&
      reconciliationData.length > 0
    "
  >
    <v-card elevation="2">
      <v-row justify="space-between">
        <v-col cols="6" sm="8" class="py-0">
          <v-card-title primary-title>Reconciliation Summary - {{ this.reportMode }}</v-card-title>
        </v-col>
      </v-row>
      <v-data-table
        :loading="load"
        :headers="headers"
        :items="reconciliationData"
        :search="search"
        :sort-desc="[true]"
        hide-default-footer
        multi-sort
        loading-text="Loading data..."
        class="elevation-0 col-md-12 m-auto"
      >
        <template v-if="reconciliationData && reconciliationData.length > 0" v-slot:header="{ headers }">
          <thead>
            <tr>
              <th v-for="header in headers">
                {{ header }}
              </th>
            </tr>
          </thead>
        </template>

        <template v-if="reconciliationData && reconciliationData.length > 0" v-slot:body="{ items }">
          <tbody>
            <tr>
              <td class="font-weight-bold">Membership</td>
              <td v-for="item in reconciliationData" :key="item.groupName">
                {{ item.Member_Months }}
              </td>
              <td class="font-weight-bold">
                {{ recSummary.Member_Months }}
              </td>
            </tr>
            <tr>
              <td class="font-weight-bold">Funding</td>
              <td class="font-weight-bold" v-for="item in reconciliationData" :key="item.groupName">
                {{ item.Funding }}
              </td>
              <td class="font-weight-bold">
                {{ recSummary.Funding }}
              </td>
            </tr>
            <tr v-if="insurance === 'Humana'">
              <td class="text-right">Part A</td>
              <td v-for="item in reconciliationData" :key="item.groupName">
                {{ item.PartAFunding }}
              </td>
              <td class="font-weight-bold">
                {{ recSummary.PartAFunding }}
              </td>
            </tr>
            <tr v-if="insurance === 'Humana'">
              <td class="text-right">Part B</td>
              <td v-for="item in reconciliationData" :key="item.groupName">
                {{ item.PartBFunding }}
              </td>
              <td class="font-weight-bold">
                {{ recSummary.PartBFunding }}
              </td>
            </tr>
            <tr>
              <td class="font-weight-bold">Claims Expense</td>
              <td class="font-weight-bold" v-for="item in reconciliationData" :key="item.groupName">
                {{ item.ClaimsExp }}
              </td>
              <td class="font-weight-bold">
                {{ recSummary.ClaimsExp }}
              </td>
            </tr>
            <tr v-if="insurance === 'Freedom' || insurance === 'Optimum'">
              <td class="text-right">Part A</td>
              <td v-for="item in reconciliationData" :key="item.groupName">
                {{ item.Part_A }}
              </td>
              <td class="font-weight-bold">
                {{ recSummary.Part_A }}
              </td>
            </tr>
            <tr v-if="insurance === 'Freedom' || insurance === 'Optimum'">
              <td class="text-right">Part B</td>
              <td v-for="item in reconciliationData" :key="item.groupName">
                {{ item.Part_B }}
              </td>
              <td class="font-weight-bold">
                {{ recSummary.Part_B }}
              </td>
            </tr>
            <tr v-if="insurance === 'Freedom' || insurance === 'Optimum'">
              <td class="text-right">Part D</td>
              <td v-for="item in reconciliationData" :key="item.groupName">
                {{ item.Part_D }}
              </td>
              <td class="font-weight-bold">
                {{ recSummary.Part_D }}
              </td>
            </tr>
            <tr v-if="insurance === 'Humana'">
              <td class="text-right">Part A</td>
              <td v-for="item in reconciliationData" :key="item.groupName">
                {{ item.PartAExpense }}
              </td>
              <td class="font-weight-bold">
                {{ recSummary.PartAExpense }}
              </td>
            </tr>
            <tr v-if="insurance === 'Humana'">
              <td class="text-right">Part B</td>
              <td v-for="item in reconciliationData" :key="item.groupName">
                {{ item.PartBExpense }}
              </td>
              <td class="font-weight-bold">
                {{ recSummary.PartBExpense }}
              </td>
            </tr>
            <tr>
              <td class="font-weight-bold">Cap Expense</td>
              <td v-for="item in reconciliationData" :key="item.groupName">
                {{ item.CapExpense }}
              </td>
              <td class="font-weight-bold">
                {{ recSummary.CapExpense }}
              </td>
            </tr>
            <tr v-if="insurance === 'Freedom' || insurance === 'Optimum'">
              <td class="text-right">PCP Cap</td>
              <td v-for="item in reconciliationData" :key="item.groupName">
                {{ item.PCP_Cap }}
              </td>
              <td class="font-weight-bold">
                {{ recSummary.PCP_Cap }}
              </td>
            </tr>
            <tr v-if="insurance === 'Freedom' || insurance === 'Optimum'">
              <td class="text-right">Specialist Cap</td>
              <td v-for="item in reconciliationData" :key="item.groupName">
                {{ item.Specialist_Cap }}
              </td>
              <td class="font-weight-bold">
                {{ recSummary.Specialist_Cap }}
              </td>
            </tr>
            <tr v-if="insurance === 'Careplus' || insurance === 'Freedom' || insurance === 'Optimum'">
              <td class="font-weight-bold">Reinsurance</td>
              <td v-for="item in reconciliationData" :key="item.groupName">
                {{ item.Reinsurance }}
              </td>
              <td class="font-weight-bold">
                {{ recSummary.Reinsurance }}
              </td>
            </tr>
            <tr v-if="insurance === 'Careplus'">
              <td class="font-weight-bold">Specialty Cap</td>
              <td v-for="item in reconciliationData" :key="item.groupName">
                {{ item.SpecialtyCap }}
              </td>
              <td class="font-weight-bold">
                {{ recSummary.SpecialtyCap }}
              </td>
            </tr>
            <tr>
              <td class="font-weight-bold">Manual Adj.</td>
              <td v-for="item in reconciliationData" :key="item.groupName">
                {{ item.Manual_Adj }}
              </td>
              <td class="font-weight-bold">
                {{ recSummary.Manual_Adj }}
              </td>
            </tr>
            <tr v-if="insurance === 'Humana'">
              <td class="font-weight-bold">Withheld</td>
              <td v-for="item in reconciliationData" :key="item.groupName">{{ item.Withheld }}</td>
              <td class="font-weight-bold">
                {{ recSummary.Withheld }}
              </td>
            </tr>
            <tr>
              <td class="font-weight-bold">IBNR</td>
              <td v-for="item in reconciliationData" :key="item.groupName">{{ item.IBNR }}</td>
              <td class="font-weight-bold">
                {{ recSummary.IBNR }}
              </td>
            </tr>
            <tr v-if="insurance === 'Humana' || insurance === 'Freedom' || insurance === 'Optimum'">
              <td class="font-weight-bold">Stoploss</td>
              <td v-for="item in reconciliationData" :key="item.groupName">{{ item.Stoploss }}</td>
              <td class="font-weight-bold">
                {{ recSummary.Stoploss }}
              </td>
            </tr>
            <tr v-if="insurance === 'Careplus'">
              <td class="font-weight-bold">Reserve Fee</td>
              <td v-for="item in reconciliationData" :key="item.groupName">
                {{ item.Reserve }}
              </td>
              <td class="font-weight-bold">
                {{ recSummary.Reserve }}
              </td>
            </tr>
            <tr v-if="insurance === 'Careplus'">
              <td class="font-weight-bold">Plan Share</td>
              <td class="font-weight-bold" v-for="item in reconciliationData" :key="item.groupName">
                {{ item.PlanShare }}
              </td>
              <td class="font-weight-bold">
                {{ recSummary.PlanShare }}
              </td>
            </tr>
            <tr v-if="insurance === 'Humana' || insurance === 'Freedom' || insurance === 'Optimum'">
              <td class="font-weight-bold">Net</td>
              <td class="font-weight-bold" v-for="item in reconciliationData" :key="item.groupName">
                {{ item.Net }}
              </td>
              <td class="font-weight-bold">
                {{ recSummary.Net }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

export default {
  name: 'Reconciliation',
  props: ['organization', 'groups', 'insurance', 'startDate', 'endDate', 'reportData'],
  data() {
    return {
      search: '',
      load: false,
      pagination: '',
      reconciliationData: [],
      recGross: {},
      recNet: {},
      recSummary: {},
      expanded: [],
      headers: [],
      pmpm: false,
      cancelSource: null,
    };
  },
  mounted() {
  },
  methods: {
    async getHeaders() {
      this.headers = [];

      if (this.reconciliationData) {
        this.reconciliationData.forEach((group) => {
          this.headers.push({ text: group.groupName, value: group.groupName });
        });
      }

      this.headers.unshift({ text: 'Metric', value: '', width: 10 }); // first column that will display metric name
      this.headers.push({ text: 'Summary', value: '' });

    },
    formatCurrency(c) {
      if (c != undefined) return c.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    },
    cancelSearch() {
      if (this.cancelSource) {
        this.cancelSource.cancel('Start new search, stop active search');
      }
    },
  },
  computed: {
    reportMode() {
      if (this.pmpm == true) {
        return 'PMPM';
      }
      return 'Gross';
    },
  },
  watch: {
    async reportData() {
      const d = this.reportData;
      if (!d || typeof d !== 'object' || Array.isArray(d)) {
        this.recSummary = {};
        this.reconciliationData = [];
        this.getHeaders();
        return;
      }
      this.recSummary = d.recSummary || {};
      this.reconciliationData = d.reconData || [];
      this.getHeaders();
    },
  },
};
</script>
<style scoped>
table > tbody > tr > td:nth-child(1),
table > thead > tr > th:nth-child(1) {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: 0;
  z-index: 8;
  background: white;
  border-right: 1px solid #f0f0f0;
}
table > thead > tr > th:nth-child(1) {
  z-index: 9;
}
.theme--dark.v-data-table > .v-data-table__wrapper > table > tbody > tr > td:nth-child(1) {
  background: #1e1e1e;
  border-color: rgba(255, 255, 255, 0.12);
}
</style>
